import { FC, LegacyRef, useMemo } from 'react'

import { Select, Stack, Typography } from '@forto-dev/phoenix-ui-core'
import { validateCountryCode } from '@freighthub/reference-master-data'

import { getCountryDisplayNameFromCode, isoCountriesDescriptions } from '@/features/companyAccount'
import { LanguageCode, useLocalisation } from '@/utils/localisation'

export type CountrySelectorProps = {
  label?: string
  placeholder?: string
  value?: string
  required?: boolean
  disabled?: boolean
  inputRef?: LegacyRef<HTMLInputElement>
  error?: boolean
  hint?: string
  warningMessage?: string
  onChange?: (countryCode: string) => void
}

const countryCodes = Object.keys(isoCountriesDescriptions).filter(validateCountryCode)

export const CountrySelector: FC<CountrySelectorProps> = (props) => {
  const { label, placeholder, required, disabled, value, inputRef, error, hint, warningMessage, onChange } = props

  const { currentLanguage } = useLocalisation()

  const countryOptions = useMemo(
    () =>
      countryCodes.map((countryCode) => ({
        label: getCountryDisplayNameFromCode(countryCode, currentLanguage as LanguageCode),
        value: countryCode,
      })),
    [currentLanguage]
  )

  return (
    <Stack gap={2}>
      <Select
        required={required}
        searchable
        label={label}
        placeholder={placeholder}
        state={error ? 'negative' : undefined}
        onChange={onChange}
        ref={inputRef}
        hint={hint}
        items={countryOptions}
        disabled={disabled}
        value={value}
      />
      {!error && !!warningMessage && (
        <Typography variant="small" color="warning">
          {warningMessage}
        </Typography>
      )}
    </Stack>
  )
}
